module.exports = __webpack_public_path__ + "static/img/home11.f6bf908d.png";